import { Injectable } from '@angular/core';
import {configurationCode} from '../utils/utils';
import {RestApiService} from '../../shared/services/rest-api.service';
import {ConfigurationService} from './impl/configuration/configuration.service';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {ApplicationStateService} from '../../shared/services/application-state.service';
import {InsurerDataModeConfig} from '../../shared/sections/web/insurer-data-section/insurer-data-mode-config';
import {InsuranceCompanyService} from '../../shared/services/insurance-company.service';

@Injectable({
  providedIn: 'root'
})
export class InsuranceCompanyApiService {

  modeConfig: InsurerDataModeConfig;
  private citiesDictionaryEndpoint: string;
  private streetsDictionaryEndpoint: string;
  private bankNameDictionaryEndpoint: string;

  get addressDataCode(): string {
    const config = this.insuranceCompanyService.getInsuranceCompanyConfig(this.stateService.insuranceCompanyCode);
    if (isNotNullOrUndefined(config) && isNotNullOrUndefined(config.addressDataCode)) {
      return config.addressDataCode;
    }
    return '';
  }

  constructor(private api: RestApiService,
              private configuration: ConfigurationService,
              private stateService: ApplicationStateService,
              private insuranceCompanyService: InsuranceCompanyService) {
    this.citiesDictionaryEndpoint = this.configuration.uiConfig.citiesDictionaryEndpoint;
    this.streetsDictionaryEndpoint = this.configuration.uiConfig.streetsDictionaryEndpoint;
    this.bankNameDictionaryEndpoint = this.configuration.uiConfig.bankNameDictionaryEndpoint;
  }

  findCities(postalCode: string, cityName?: string): Promise<FindCitiesResponse> {
    const body = {
      findCitiesByPostalCode: {
        configurationCode: configurationCode(),
        address: {
          postalCode: postalCode,
          city: cityName ? cityName : ''
        },
        insuranceCompanyName: this.addressDataCode
      }
    };

    const headers = {
      'Accept': 'application/json'
    };

    return this.api.post(this.citiesDictionaryEndpoint, body, true, headers);
  }

  findStreets(postalCode: string, cityName: string, cityId?: number, streetName?: string): Promise<FindStreetsResponse> {
    const body = {
      findStreets: {
        configurationCode: configurationCode(),
        postalCode: postalCode,
        cityName: cityName,
        street: streetName ? streetName : '',
        insuranceCompanyName: this.addressDataCode,
        cityId: cityId
      }
    };

    const headers = {
      'Accept': 'application/json'
    };

    return this.api.post(this.streetsDictionaryEndpoint, body, true, headers);
  }

  findBanks(postalCode: string): Promise<FindStreetsResponse> {
    const postalCodeEndpoint = this.bankNameDictionaryEndpoint + `?postalCode=${postalCode}&configurationCode=${configurationCode()}`;

    const headers = {
      'Accept': 'application/json'
    };

    return this.api.get(postalCodeEndpoint, {}, true, headers);
  }
}

export interface FindCitiesResponse {
  findCitiesByPostalCodeResponse: {
    cityList: {
      city: CityItem[]
    }
  }
  hint?: boolean;
}

export interface CityItem {
  cityName: string;
  cityId?: number;
}

export interface BankId {
  bankId: string;
}

export interface FindStreetsResponse {
  findStreetsResponse: {
    streetsList: {
      streetName: string[]
    };
    hint?: boolean;
  }
}

